import React from 'react';
import './Footer.css';

const Footer = () => {
  const quickLinks = [
    { title: 'Giới thiệu', link: '#about' },
    { title: 'Dự án điện mặt trời', link: '#projects' },
    { title: 'Thiết bị vật tư', link: '#equipment' },
    { title: 'Tin tức', link: '#news' },
    { title: 'Liên hệ', link: '#contact' }
  ];

  const services = [
    { title: 'Điện mặt trời hộ gia đình', link: '#residential' },
    { title: 'Điện mặt trời doanh nghiệp', link: '#commercial' },
    { title: 'Tư vấn lắp đặt', link: '#consultation' },
    { title: 'Bảo trì hệ thống', link: '#maintenance' },
    { title: 'Hỗ trợ trả góp', link: '#financing' }
  ];

  const offices = [
    {
      name: 'Trụ sở chính',
      address: 'Khu công nghiệp Lai Xá - Kim Chung - Hoài Đức - Hà Nội',
      phone: '0989.786.995 - 0983.913.951',
      email: 'gninelighting26@gmail.com'
    }
  ];

  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <div className="footer-logo">
                  <span className="logo-text">GNINE</span>
                  <span className="logo-highlight">GROUP</span>
                </div>
                <p className="footer-company-name" style={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: '0.5rem' }}>
                  Công ty cổ phần sản xuất &amp; thương mại G-Nine Việt Nam
                </p>
                <p className="footer-about">
                  GNINE SOLAR tự hào là đơn vị lắp đặt điện mặt trời uy tín hàng đầu Việt Nam,
                  mang đến giải pháp năng lượng xanh bền vững cho hộ gia đình và doanh nghiệp.
                </p>
                <div className="footer-social">
                  <a href="https://www.facebook.com/profile.php?id=61573208079961" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#" className="social-link" aria-label="Youtube">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href="#" className="social-link" aria-label="Zalo">
                    <i className="fas fa-comment-dots"></i>
                  </a>
                  <a href="#" className="social-link" aria-label="TikTok">
                    <i className="fab fa-tiktok"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <h4 className="widget-title">Liên kết nhanh</h4>
                <ul className="footer-links">
                  {quickLinks.map((item, index) => (
                    <li key={index}>
                      <a href={item.link}>
                        <i className="fas fa-chevron-right"></i>
                        {item.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <h4 className="widget-title">Dịch vụ</h4>
                <ul className="footer-links">
                  {services.map((item, index) => (
                    <li key={index}>
                      <a href={item.link}>
                        <i className="fas fa-chevron-right"></i>
                        {item.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4 className="widget-title">Liên hệ</h4>
                <div className="footer-contact">
                  {offices.map((office, index) => (
                    <div key={index} className="contact-item">
                      <h5>{office.name}</h5>
                      <p>
                        <i className="fas fa-map-marker-alt"></i>
                        {office.address}
                      </p>
                      {office.phone && (
                        <p>
                          <i className="fas fa-phone-alt"></i>
                          <a href={`tel:${office.phone.replace(/\./g, '')}`}>{office.phone}</a>
                        </p>
                      )}
                      {office.email && (
                        <p>
                          <i className="fas fa-envelope"></i>
                          <a href={`mailto:${office.email}`}>{office.email}</a>
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright">
                &copy; {new Date().getFullYear()} Công ty cổ phần sản xuất &amp; thương mại G-Nine Việt Nam. All rights reserved.
              </p>
            </div>
            <div className="col-md-6">
              <div className="footer-bottom-links">
                <a href="#">Chính sách bảo mật</a>
                <a href="#">Điều khoản sử dụng</a>
                <a href="#">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
